import { Validator } from '@vista-digital/validator';
import { defaultOrderTotalsAssets, orderTotalsAssetsValidator } from './assets';
import { defaultOrderTotalsConfig, orderTotalsConfigValidator } from './config';
export const orderTotalsPropsValidator = Validator.object({
    config: orderTotalsConfigValidator,
    assets: orderTotalsAssetsValidator
});
export const defaultOrderTotalsProps = {
    config: defaultOrderTotalsConfig,
    assets: defaultOrderTotalsAssets
};
